import React from "react";
import classNames from "classnames";

import { ArrowIcon } from "@common/assets/arrowIcon";
import { Props } from "./types";
import styles from "./styles.scss";

function Section({
  header,
  list,
  isHeaderToggleDisabled = false,
  style,
  isOpen: open = false,
}: Props) {
  const [isOpen, setIsOpen] = React.useState(open);

  React.useEffect(() => {
    open !== isOpen && setIsOpen(open);
  }, [open]);

  return (
    <div
      className={classNames(styles.section, { [styles.open]: isOpen })}
      style={style}
    >
      <div
        className={styles.header}
        onClick={!isHeaderToggleDisabled ? () => setIsOpen(!isOpen) : undefined}
      >
        {header}
        <div
          className={styles.iconBox}
          onClick={
            isHeaderToggleDisabled ? () => setIsOpen(!isOpen) : undefined
          }
        >
          <ArrowIcon className={styles.icon} />
        </div>
      </div>
      {isOpen && (
        <div className={!!style ? styles.customList : styles.list}>{list}</div>
      )}
    </div>
  );
}

export { Section };
